<template>
  <button class="clear-btn" title="Close chat" @click="chatBotStore.toggleChat()">Close Chat</button>
</template>
<script setup lang="ts">
import { useChatBotStore } from "../stores/chatBotStore";
const chatBotStore = useChatBotStore();
</script>
